import firebase from 'firebase'
import Box from '@material-ui/core/Box'
import { FcGoogle } from 'react-icons/fc'
import Link from '@material-ui/core/Link'
import Grid from '@material-ui/core/Grid'
import { useForm } from 'react-hook-form'
import { useHistory } from 'react-router'
import { AuthStyles } from './auth.module'
import { useEffect, useState } from 'react'
import Avatar from '@material-ui/core/Avatar'
import Button from '@material-ui/core/Button'
import { IFormLogin } from '../../types/forms'/* 
import { FaFacebookSquare } from 'react-icons/fa' */
import Copyright from '../../components/Copyright'
import Container from '@material-ui/core/Container'
import DividerText from '../../components/DividerText'
import { Typography, useTheme } from '@material-ui/core'
import { useSession } from '../../context/SessionContext'
import { JustiInputText } from '../../components/InputText'
import Alert, { ActionsOptType } from '../../components/Alert'

/**
 * Custom `Login` component declaration.
 * This component is used to login user and functionalities
 * @return Login
*/
const Login = (): JSX.Element => {
  const classes = AuthStyles()
  const history = useHistory()
  const theme = useTheme()
  const { message, autenticated, token, loginvalidator, loginGoogle, /* loginFacebook */ } = useSession()
  const { control, handleSubmit, errors } = useForm<IFormLogin>()
  const [alertOptions, setAlertOptions] = useState<ActionsOptType>({
    message: null,
    type: null,
    open: false,
  })

  /**
   * This method is used to validate login
   * @param {string} username
   * @param {string} password
   * @Return {void}
  */
  const onSubmit = ({ username, password }: IFormLogin) => {
    try
    {
      if(loginvalidator)
      {
        loginvalidator(username, password);
      }
    }
    catch {
      setAlertOptions({
        message: '¡UPPPS! SOMETHING WRONG IN PROCESS LOGIN',
        type: 'error',
        open: true,
      })
    } 
  }

  /**
   * This method is used to redirect the app
   * @Return {void}
  */
  useEffect(() => {
    if (autenticated || token) {
      history.push('/docengine')
    }
    if (message) {
      setAlertOptions({ message: message.text, open: true, type: message.type })
    }
  }, [message, autenticated, history])

  return (
    <Container
      component="main"
      maxWidth="xs"
      style={{ height: '100vh', display: 'flex' }}
    >
      <Alert alertOptions={alertOptions} setAlertOptions={setAlertOptions} />

      <div className={classes.paper}>
        <Avatar
          alt="JustiExpress"
          src="/logo.png"
          className={classes.JustiLogo}
        />

        <form
          className={classes.form}
          noValidate
          onSubmit={handleSubmit(onSubmit)}
        >
          <JustiInputText
            name={'username'}
            copy={'Usuario'}
            // regex={/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i}
            errorMessage={'Usuario inválido'}
            errors={errors}
            control={control}
            autoFocus={true}
          />
          <JustiInputText
            name={'password'}
            copy={'Contraseña'}
            type={'password'}
            // regex={/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z]{6,}$/}
            errorMessage={'Contraseña incorrecta'}
            errors={errors}
            control={control}
          />

          <Button
            style={{ marginTop: '2.5vh' }}
            type="submit"
            disabled={Object.keys(errors).length > 0}
            fullWidth
            variant="contained"
            className={classes.submit}
          >
            INGRESAR
          </Button>
        </form>
        <Grid container alignItems="center">
          <Grid item xs={12} style={{ marginTop: '1.0vh', marginBottom: '0.5vh' }}>
            <Link className={classes.link} href="/register" variant="body2">
              <Box textAlign="center">¿No tienes una cuenta? Regístrate</Box>
            </Link>
          </Grid>
          <Grid item xs={12}>
            <Link className={classes.link} href="/recover-password" variant="body2">
              <Box textAlign="center">¿Olvidaste tu contraseña?</Box>
            </Link>
          </Grid>       
          <Grid
            item
            xs={12}
            style={{ marginTop: '2.5vh', marginBottom: '3.5vh' }}
          >
            <DividerText text={'o ingresa con'} spacing={3} />
          </Grid>
          <Grid item xs={12} style={{ textAlign: 'center' }}>
            <FcGoogle
              size={'2em'}
              onClick={async () => {
                try {
                  const provider = new firebase.auth.GoogleAuthProvider()
                  const result = await firebase.auth().signInWithPopup(provider)
                  if (result) {
                    if (loginGoogle) loginGoogle(result.user)
                  }
                } catch {
                  console.error('¡UPPPS! SOMETHING WRONG IN PROCESS LOGIN')
                }
              }}
            />
            {/* <FaFacebookSquare
              style={{ marginLeft: '1.0vh'}}
              size={'2em'}
              onClick={async () => {
                try {
                  const provider = new firebase.auth.FacebookAuthProvider()
                  const result = await firebase.auth().signInWithPopup(provider)
                  if (result) {
                    if (loginFacebook) loginFacebook(result.user)
                  }
                } catch {
                  console.error('¡UPPPS! SOMETHING WRONG IN PROCESS LOGIN')
                }
              }}
            /> */}
          </Grid>
        </Grid>
        <Box mt={4}>
          <Typography
            style={{ whiteSpace: 'pre-line' }}
            variant="body2"
            color="textSecondary"
            align="center"
          >
            {'Al ingresar estás aceptando nuestros \n'}
            <Link
              variant="body2"
              href="https://justiexpressdev.github.io/landing/terminos-y-condiciones.html"
              style={{ color: theme.palette.secondary.dark }}
            >
              {'Términos y Condiciones '}
            </Link>
            y
            <Link
              variant="body2"
              href="https://justiexpressdev.github.io/landing/aviso-de-privacidad.html"
              style={{ color: theme.palette.secondary.dark }}
            >
              {' Política de Privacidad'}
            </Link>
          </Typography>
          <Copyright />
        </Box>
      </div>
    </Container>
  )
}

export default Login